import { Button } from '@heroui/react';
import styled from 'styled-components';

type SizeProps = 'small' | 'medium' | 'large' | undefined

const getSize = (s :SizeProps) : string => {
  switch (s) {
    case 'small':
      return '50px';
    case 'medium':
      return '450px';
    case 'large':
      return '700px';
    default:
      return '500px';
  }
};
export const FileUploaderWrapper = styled.div`
    width: 100%;
    position: relative;
`;

export const DraggableArea = styled.div<{ $isDragging: boolean; $isSingle: boolean; size: SizeProps }>`
    display: flex;
    flex-direction: column;
    align-items:  ${({ size }) => (size === 'small' ? 'flex-start' : 'center')};
    justify-content: ${({ $isSingle }) => ($isSingle ? 'center' : 'flex-start')};
    width: 100%;
    height: ${({ size }) => (getSize(size))};
    cursor: pointer;
    border: ${({ size }) => (size === 'medium' ? '2px dashed #dcdfe4' : '2px dashed transparent ')};
    box-sizing: border-box;
    border-radius: 6px;
`;

export const ActionsButtonWrapper = styled.div`
    position: absolute;
    bottom: 20px; 
    gap: 10px;
    width: calc(100% - 40px); 
    padding: 10px; 
    display: flex;
    align-items: center;
    justify-content: center; 
`;

export const CloseWrapper = styled.div<{ $isDragging: boolean }>`
    position: absolute;
    top: 15px;
    right: 14px;
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
    z-index: 5;
    padding: 9px;
    background: #fff;
    border-left: 2px dashed ${({ $isDragging }) => ($isDragging ? '#1a4d4d' : '#dcdfe4')};
    border-bottom: 2px dashed ${({ $isDragging }) => ($isDragging ? '#1a4d4d' : '#dcdfe4')};
    border-bottom-left-radius: 5px;
`;

export const UploadFileButton = styled.div`
    width: 200px;
    height: 45px;
    text-align: center;
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
    background: #1a4d4d;
    color: #fff;
    font-size: 14px;
    font-weight: 400;
    border-radius: 6px;
`;

export const DragLabel = styled.span`
    font-size: 14px;
    color: #a5a6a8;
    padding:2px 0;
`;

export const ImagePreviewRow = styled.div`
    width: 100%;
    max-width: 600px;
    display: flex;
    flex-direction: row; 
    padding: 15px 10px;
    &:not(:last-child) {
        border-bottom:1px solid #dcdfe4;
      }
`;

export const ImagePreviewWrapper = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 100px;
    padding: 10px 5px;
    border: 1px solid #e5e5e5;
    img {
        width: auto;
        max-height: 90px;
        object-fit: cover;
    }
`;

export const ImagePreviewRowAction = styled.div`
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    justify-content: space-between;
    padding: 10px 5px; 
`;

export const FileName = styled.p`
    font-size: 14px;
    font-weight: 500;
    color: #5e5e5e;
    margin: 0;
    width: 260px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;

export const FileSize = styled.p`
    font-size: 12px;
    font-weight: 500;
    color: #a5a6a8;
    margin: 0;
`;

export const CustomButton = styled(Button)<{color?: string}>`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 14px;
    color: ${(props) => props.color || '#000'};
    font-weight: 400; 
    background: transparent;
    padding: 2px 0;
    &:hover {
        text-decoration: underline;
    }
`;

export const FilesInfo = styled.p`
    font-size: 14px;
    font-weight: 500;
    color: #a5a6a8; 
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    padding-top: 25px;
    gap: 5px;
    width: 100%;
    max-width: 579px;
    text-align: left; 
`;

export const UploadTitle = styled.p`
    font-size: 22px;
    font-weight: 400;
    color: #a5a6a8; 
    display: flex;
    align-items: center;  
    justify-content: center;
    width: 100%;
    max-width: 579px;
    text-align: center; 
`;

export const UploadDescription = styled.p`
    font-size: 14px;
    font-weight: 400;
    color: #a5a6a8; 
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 579px;
    text-align: left; 
`;
